document.addEventListener("BSS:changeVariantQV", e => {
  setTimeout(() => {
    const productForm = document.querySelector("[bss-b2b-quickview-product-form], [bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  }, 1000);
});

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));

        const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
      }, 1000);
    }
  });
});
